module.exports = __webpack_public_path__ + "img/icon4.e6f86abc.jpg";